import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useModalLayout } from '#pplx/frontend/aether/components/Modal/internal/ModalLayoutContext.js';
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import * as Dialog from '@radix-ui/react-dialog';
import classNames from 'classnames';
/**
 * Compound component for `Modal.Header`.
 *
 * Renders the dialog title and optional description. Must be rendered as a
 * direct child of `<Modal>`.
 *
 * @example
 * ```tsx
 * <Modal onClose={onClose}>
 *   <Modal.Header title="Edit bookmark" />
 *   <Modal.Body>
 *     <form>...</form>
 *   </Modal.Body>
 *   <Modal.Footer>
 *     <Button>Save</Button>
 *   </Modal.Footer>
 * </Modal>
 * ```
 */
export function ModalHeader({ title, description }) {
    const { hasCloseButton } = useModalLayout();
    // Padding is owned by the modal panel (see `ModalContent`). The header
    // adds none of its own and only retains close-button collision avoidance.
    const descriptionElement = description ? (_jsx(Dialog.Description, { className: "text-tertiary text-sm", children: _jsx("span", { className: "block", children: description }) })) : null;
    return (_jsxs(_Fragment, { children: [_jsx(Dialog.Title, { asChild: true, children: _jsx(TextPrimitive, { size: "lg", weight: "medium", className: classNames({
                        'pr-[calc(var(--spacing-8)+2.5rem)]': hasCloseButton,
                    }), children: _jsx("div", { children: title }) }) }), descriptionElement] }));
}
/**
 * Custom title wrapper for modals that need bespoke title typography.
 */
export function ModalTitle({ children }) {
    return _jsx(Dialog.Title, { asChild: true, children: children });
}
//# sourceMappingURL=ModalHeader.js.map